export default __webpack_public_path__ + "static/media/Criativa Festas.89ea0e2a.png";